var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-vcs-root-S-arrow",
  "use": "ring-icon-vcs-root-S-arrow-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"ring-icon-vcs-root-S-arrow\"><path d=\"M5.29 6l2.54 3.94 1.28 2V12L13 6zM7 5V3H6v2zM2 8V2h6v3h2V0H0v10h6.69L5.4 8zm1-5v2.22l1.7 1.7.59-.92L4 4.75V3z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id